<!-- 乐乐模式：左侧分屏布局 -->
<template>
  <div class="live-split-view" v-if="isLeLeInteractMode || isLiveCommerceMode">
    <div class="live-split-view__left">
      <!-- 实时并发数据看板展示区 -->
      <div
        class="live-split-view__data-box"
        v-if="configList['watch_data_panel'] == 1 && (roleName == 1 || roleName == 3)"
      >
        <DataBoard class="card" />
      </div>

      <!-- 互动工具内容展示区 -->
      <div class="live-split-view__interact-box card">
        <div class="empty-box" v-if="!currentInteractTool">
          <EmptyData :tip="$t('host.k_528001')" />
        </div>
        <component v-else :is="currentInteractTool"></component>
      </div>
    </div>
    <div class="live-split-view__right">
      <!-- 聊天审核 -->
      <ChatAuthPane class="chat-auth card" v-if="hasChatAuth" />
      <AiChat class="ai-chat card" v-if="hasRobotChatAuth"></AiChat>
    </div>
  </div>
</template>
<script>
  import { emitter, EMIT_DEFINE } from '@/app-shared/utils/emitter.js';
  import { useMsgServer } from 'middle-domain';
  export default {
    name: 'LiveSplitView',
    components: {
      DataBoard: () => import('../components/dataBoard.vue'),
      EmptyData: () => import('@/app-shared/components/empty-data/index.vue'),
      ChatAuthPane: () => import('@/packages/chat-auth-pane/src/main.vue'),
      LiveLotteryList2: () => import('@/packages/lottery/src/live/components/lottery-list2.vue'),
      LiveExamList2: () => import('@/packages/exam/src/components/exam-list2.vue'),
      SignLive2: () => import('@/packages/sign-module/sign-live/src/main2.vue'),
      PunchLive: () => import('@/packages/punch-module/punch-live/main.vue'),
      AiChat: () => import('../components/aiChat.vue'),
      WatchGiftList: () => import('@/packages/watch-gift/live/WatchGiftList.vue'),
      MallRewardLiveList: () => import('@/packages/mall-reward/src/live/MallRewardLiveList.vue'),
      InactiveKickMain2: () => import('@/packages/inactive-kick/live/main2.vue')
    },
    data() {
      return {
        currentInteractTool: '' // 当前展示的互动工具
      };
    },
    computed: {
      isLiving() {
        return this.$domainStore.state.roomBaseServer.watchInitData.webinar.type == 1;
      },
      roleName() {
        return this.$domainStore.state.roomBaseServer.watchInitData.join_info.role_name;
      },
      configList() {
        return this.$domainStore.state.roomBaseServer.configList;
      },
      // 是否工具简单模式（乐乐专属）
      isLeLeInteractMode() {
        return this.configList?.['lele_interact_model'];
      },
      // 是否直播带货模式
      isLiveCommerceMode() {
        return this.configList?.['live_commerce_model'];
      },
      // guodu  权限
      auth_gd() {
        return this.$domainStore.state.roomBaseServer.embedSource == 'gd';
      },
      // 是否有聊天审核功能权限
      hasChatAuth() {
        // 主持人，助理，嘉宾 且开启了权限
        return (
          [1, 3, 4].includes(this.roleName) && this.configList['comment_check'] && !this.auth_gd
        );
      },
      // 是否有机器人聊天权限
      hasRobotChatAuth() {
        const robotChatConfig = this.configList?.['robot_chat'];
        return (
          (robotChatConfig == 1 || robotChatConfig === undefined) &&
          !this.auth_gd &&
          [1, 3, 4].includes(this.roleName)
        );
      }
    },
    beforeCreate() {
      this.msgServer = useMsgServer();
    },
    created() {
      this.initEvent();
    },
    methods: {
      initEvent() {
        emitter.on(EMIT_DEFINE.live_sidemenu_change, this.handleSidemenuChange);
        this.msgServer.$on('live_over', this.handleLiveOver); //直播结束
      },
      // 直播结束
      handleLiveOver() {
        this.currentInteractTool = '';
        emitter.emit(EMIT_DEFINE.live_sidemenu_change, { kind: '' });
      },
      handleSidemenuChange(option) {
        console.log('handleSidemenuChange option==:', option);
        switch (option?.kind) {
          case 'lottery': // 抽奖
            this.currentInteractTool = 'LiveLotteryList2';
            break;
          case 'exam': // 快问快答
            this.currentInteractTool = 'LiveExamList2';
            break;
          case 'sign': // 签到
            this.currentInteractTool = 'SignLive2';
            break;
          case 'punch': // 打卡
            this.currentInteractTool = 'PunchLive';
            break;
          case 'mallreward': // 商城奖励
            this.currentInteractTool = 'MallRewardLiveList';
            break;
          case 'watchgift': // 观看有礼
            this.currentInteractTool = 'WatchGiftList';
            break;
          case 'inactive_kick': // 未互动踢出直播间
            this.currentInteractTool = 'InactiveKickMain2';
            break;
        }
      }
    },
    beforeDestroy() {
      emitter.off(EMIT_DEFINE.live_sidemenu_change, this.handleSidemenuChange);
      this.msgServer.$off('live_over', this.handleLiveOver); //直播结束
    }
  };
</script>
<style lang="less">
  .live-split-view {
    position: relative;
    width: 100%;
    height: 100%;
    z-index: 3;
    display: flex;
    flex-direction: row;
    background-color: #f3f4f8;
    overflow: auto;
    &::-webkit-scrollbar-thumb {
      background-color: #666;
      /* 设置滚动条滑块的颜色为灰色 */
      border-radius: 6px;
      /* 设置滑块的圆角半径 */
    }

    .card {
      border-radius: 8px;
      background-color: #fff;
    }
    &__left {
      display: flex;
      flex-direction: column;
    }

    &__data-box {
      min-height: 144px;
      margin: 12px 12px 0 12px;
      border-radius: 8px;
      background-color: #fff;
    }

    &__interact-box {
      flex: 1;
      width: 480px;
      margin: 12px;
      border-radius: 8px;
      background-color: #fff;
      overflow: hidden;

      > .empty-box {
        height: 100%;
        display: flex;
        align-items: center;
        justify-content: center;
      }
    }

    &__right {
      flex: 1;
      margin: 12px 12px 12px 0;
      display: flex;
      flex-direction: column;
      justify-content: space-around;
      min-width: 600px;
      .ai-chat {
        height: 100px !important;
        margin-top: 12px;
      }
      .chat-auth {
        flex: 1;
        height: 0;
      }
    }
  }
</style>
